import { render } from "./NewStandardText.vue?vue&type=template&id=d57a328e"
import script from "./NewStandardText.vue?vue&type=script&lang=js"
export * from "./NewStandardText.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__